/**
 * Builds portal URLs based on environment (local dev vs. production)
 *
 * In production: subdomain-based routing (slug.app.wrenchlab.net)
 * In local dev: returns null (portal doesn't exist; use manual login with slug+code instead)
 */

function isLocalDevelopment(): boolean {
  const apiUrl = import.meta.env.VITE_API_BASE_URL || '';
  return apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1');
}

export function buildPortalUrl(slug: string | undefined | null): string | null {
  if (!slug) return null;

  // In local dev, portal subdomain routing doesn't work without real DNS/wildcard certs
  if (isLocalDevelopment()) {
    return null;
  }

  // Production: use subdomain-based routing
  return `https://${slug}.app.wrenchlab.net/portal`;
}

export function buildPortalSessionUrl(slug: string | undefined | null, code: string | undefined | null): string | null {
  if (!slug || !code) return null;

  if (isLocalDevelopment()) {
    return null;
  }

  return `https://${slug}.app.wrenchlab.net/api/auth/portal-session?code=${encodeURIComponent(code)}`;
}

export function buildIntakeUrl(slug: string | undefined | null): string | null {
  if (!slug) return null;

  if (isLocalDevelopment()) {
    return null;
  }

  return `https://${slug}.app.wrenchlab.net/intake`;
}

export function buildTechnicianPortalUrl(slug: string | undefined | null): string | null {
  if (!slug) return null;

  if (isLocalDevelopment()) {
    return `${window.location.origin}/technician-login`;
  }

  return `https://app.wrenchlab.net/technician-login?shop=${encodeURIComponent(slug)}`;
}
